//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export const CONTENT_LIBRARY_SOURCES_GROUPS = {
  ALL_MEDIA: 'AllMedia',
  TEAM_MEDIA: 'TeamMedia',
  ALL_TRACKED_USERS: 'AllTrackedUsers',
  ALL_TRACKED_COMPETITORS: 'AllTrackedCompetitors',
  ALL_TRACKED_HASHTAGS: 'AllTrackedHashtags',
  ALL_FACEBOOK: 'AllFacebook',
  ALL_INSTAGRAM: 'AllInstagram',
  ALL_PINTEREST: 'AllPinterest',
  ALL_BRAND_POSTS: 'AllBrandPosts',
  ALL_DROPBOX: 'AllDropbox',
  ALL_TIKTOK: 'AllTikTok',
  ALL_YOUTUBE: 'AllYouTube',
};
